<template>
	<component :is="iconTypes[name]" :style="`width: ${size / 10}rem; height: ${size / 10}rem;`" :color="color" />
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

import * as iconTypes from './libs/index';

export type IconTypes = keyof typeof iconTypes;

/**
 * 공통 아이콘 컴포넌트
 * size는 default 24 적용
 */
interface Props {
	name: IconTypes;
	size?: number;
	color?: string;
}
const props = withDefaults(defineProps<Props>(), {
	size: 24,
	color: '#ffffff',
});

const { name, size, color } = toRefs(props);
</script>

<style lang="scss" scoped></style>
